import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-402e6d88"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-live"]
const _hoisted_2 = {
  class: "connection-status-icon",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "8",
  r: "6.25",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M8 4.5V8L10.25 9.5",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "8",
  r: "6.25",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M8 5V8.25",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "11",
  r: "0.85",
  fill: "currentColor"
}, null, -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M3 8.2L6.4 11.5L13 4.5",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "connection-status-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "connection-toast" }, {
    default: _withCtx(() => [
      (_ctx.toast.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "connection-status-wrap",
            role: "status",
            "aria-live": _ctx.toast.kind === 'offline' ? 'assertive' : 'polite'
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["connection-status-toast", `is-${_ctx.toast.kind}`])
            }, [
              _createElementVNode("span", _hoisted_2, [
                (_ctx.toast.kind === 'slow')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_6))
                  : (_ctx.toast.kind === 'offline')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _hoisted_11))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
              ]),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.toast.message), 1)
            ], 2)
          ], 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}